import React, {lazy, Suspense} from "react";
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import {observer} from "mobx-react-lite";
import routes from "./routes";
import {unityStore} from "./store/unityStore";
import {authStore} from "./store/authStore";
import {dashboardStore} from "./store/dashboardStore";
import DoubleLogin from "./components/Popups/DoubleLogin";
import Loading from "./components/Loading";
import InviteShowPopup from "./components/Popups/InviteShowPopup";
import ErrorModal from "./components/ModalError";
import Mobile from "./containers/mobile";
import ParticipantsPopup from "./components/Popups/ParticipantsPopup";
import InviteToHomeSpace from "./components/Popups/InviteToHomeSpace";
import TransitionRouter from "./components/TransitionRouter";
// import InternetSpeedChecker from "./components/InternetSpeedChecker";
import background from "./assets/arleam/background.mp4";

const UnityLayout = lazy(() => import("./containers/unityLayout"));

const App = observer(() => {
  const {loadUnity, isActiveMobile} = unityStore;
  const {doubleLogin, inviteMessage} = authStore;
  const {inviteData, clearInviteData} = dashboardStore;
  // const showRotateDevice = useRotate(false);

  return (
    <Suspense fallback={null}>
        <BrowserRouter>
            <video autoPlay playsInline muted loop id="background">
                <source src={background} type="video/mp4"/>
            </video>
            <TransitionRouter>
                <Routes>
                    {routes.map((item, index) => (
                        <Route
                            key={index}
                            path={item.path}
                            element={<item.component/>}
                            title={item.title}
                            exact
                        />
                    ))}
                    <Route path="*" element={<Navigate to="/404" replace/>}/>
                </Routes>
            </TransitionRouter>
            <Suspense fallback={null}>
                {loadUnity && !isActiveMobile && <UnityLayout/>}
                {isActiveMobile && <Mobile/>}
            </Suspense>
            {doubleLogin && <DoubleLogin/>}
            {!!inviteMessage && <InviteShowPopup/>}
            {!!inviteData?.sender_user && (
                <InviteToHomeSpace
                    user={inviteData?.sender_user}
                    roomLink={inviteData?.link}
                    clearData={clearInviteData}
                />
            )}
            <ParticipantsPopup/>
            <ErrorModal/>
        </BrowserRouter>
        {/*{showRotateDevice && <RotateDevice />}*/}
        {/*<InternetSpeedChecker/>*/}
        <Loading/>
    </Suspense>
  );
});

export default App
